// extracted by mini-css-extract-plugin
export default {"productBasicSlider":"Promotions_productBasicSlider__CfaZu","prev":"Promotions_prev__AyXWd","next":"Promotions_next__mwT2p"};